export default {
  getterUnreadNoticesCount: noticesBoard => noticesBoard.unreadNoticesCount
};
